import { computed, ref, watch, type ComputedRef, type Ref } from 'vue';
import type { StoryTime } from '../types/timeline';

export function useGlobalTimeContext(options: {
  workspaceId: ComputedRef<string | null>;
  selectedTime: ComputedRef<StoryTime | null>;
  setContext: (sceneId: string | null, segmentId: string | null) => Promise<void>;
  resetContext: () => Promise<void>;
}) {
  const globalTimeContextOpen = ref(false);
  const manualGlobalTime: Ref<StoryTime | null> = ref(null);
  const globalReferenceTime = computed(() => manualGlobalTime.value ?? options.selectedTime.value);

  watch(options.workspaceId, () => {
    manualGlobalTime.value = null;
    globalTimeContextOpen.value = false;
  });

  async function selectGlobalTimeContext(sceneId: string | null, segmentId: string | null) {
    manualGlobalTime.value = null;
    await options.setContext(sceneId, segmentId);
  }
  function setGlobalReferenceDate(value: StoryTime | null) { manualGlobalTime.value = value; }
  async function resetGlobalTimeContext() {
    manualGlobalTime.value = null;
    await options.resetContext();
  }

  return { globalTimeContextOpen, globalReferenceTime, selectGlobalTimeContext, setGlobalReferenceDate, resetGlobalTimeContext };
}
